import React from "react";
// Assuming `logo` is imported here or passed as a prop
import logo from "../assets/logo.png";

const AdminLogo = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <img
        height="150"
        src={logo}
        alt="sos logo"
        style={{
          padding: "1rem",
          background: "black",
          width: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default AdminLogo;
